import React from 'react';
import TitleBox from './TitleBox';
import SideBar from './SideBar';
import {connect} from 'react-redux';
import withRouter from '../../../withRouter.js';
import {isSideBarHiddenForUiMode} from './sideBarVisibility.js';

let SideBarContainer = (props) => {
  return (
    <div className={"SideBarContainer" + (isSideBarHiddenForUiMode(props.uiHideMode) ? ' hidden' : '')}>
      <SideBar />
      <TitleBox />
    </div>
  )
}

let mapStateToProps = (state) => ({
  uiHideMode: state.ui.hideMode
})

let mapDispatchToProps = dispatch => ({})

const SideBarContainerWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(SideBarContainer));

export default SideBarContainerWrapper;
